
import React, { useState, useEffect, useRef } from "react";
import { getProductos } from "./services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import HeroWhisky from "./subComponents/HeroWhisky";
import SEO from "../SEO/SEO";
import "./Productos.css";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://whiskyandco.com.ar";

export const Productos = () => {
  const [productos, setProductos] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("TODOS");
  const [searchTerm, setSearchTerm] = useState("");
  const [ordenPrecio, setOrdenPrecio] = useState(""); // "asc" | "desc"

  const [tipoWhiskySeleccionado, setTipoWhiskySeleccionado] = useState("TODOS");
  const [tiposWhisky, setTiposWhisky] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage, setProductsPerPage] = useState(6);
  const navigate = useNavigate();

  const topRef = useRef(null);

  useEffect(() => {
    const updateProductsPerPage = () => {
      setProductsPerPage(window.innerWidth >= 1400 ? 12 : 9);
    };

    updateProductsPerPage();
    window.addEventListener("resize", updateProductsPerPage);

    return () => window.removeEventListener("resize", updateProductsPerPage);
  }, []);

  useEffect(() => {
    cargarProductos();
  }, [categoriaSeleccionada, tipoWhiskySeleccionado, searchTerm, ordenPrecio]);

  const cargarProductos = async () => {
    try {
      const response = await getProductos();
      if (response && response.status === 200) {
        let productosFiltrados = response.data.productos || [];

        if (categoriaSeleccionada !== "TODOS") {
          productosFiltrados = productosFiltrados.filter(producto =>
            producto.categoria.nombre.toUpperCase() === categoriaSeleccionada
          );
        }

        if (tipoWhiskySeleccionado !== "TODOS") {
          productosFiltrados = productosFiltrados.filter(producto =>
            producto.tipoWhisky.toUpperCase() === tipoWhiskySeleccionado
          );
        }

        if (searchTerm.trim() !== "") {
          productosFiltrados = productosFiltrados.filter(producto => {
            const search = searchTerm.toLowerCase();
            return (
              producto.nombre.toLowerCase().includes(search) ||
              producto.descripcion.toLowerCase().includes(search) ||
              producto.tipoWhisky.toLowerCase().includes(search) ||
              producto.categoria.nombre.toLowerCase().includes(search) ||
              producto.precio.toString().includes(search)
            );
          });
        }




        // 🔥 Ordenar por precio
        if (ordenPrecio === "asc") {
          productosFiltrados.sort((a, b) => a.precio - b.precio);
        } else if (ordenPrecio === "desc") {
          productosFiltrados.sort((a, b) => b.precio - a.precio);
        }

        const tiposUnicos = [...new Set(productosFiltrados.map(p => p.tipoWhisky.toUpperCase()))];
        setTiposWhisky(["TODOS", ...tiposUnicos]);

        setProductos(productosFiltrados);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("Ocurrió un error al intentar cargar los productos.");
    }
  };

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = productos.slice(indexOfFirstProduct, indexOfLastProduct);

  const totalPages = Math.ceil(productos.length / productsPerPage);

  const itemListStructuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Nuestros whiskys",
    itemListElement: currentProducts.map((producto, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `${SITE_URL}/productos/${producto.slug}`,
      name: producto.nombre,
      ...(producto.imagen ? { image: producto.imagen } : {}),
    })),
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
      scrollToTop();
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
      scrollToTop();
    }
  };


  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <div className="contenedorGeneralProductosV">
      <SEO
        title="Productos | Whisky And Co"
        description="Nuestros whiskys. Sabores que cuentan historias. Selecciona el tuyo."
        canonicalPath="/productos"
        structuredData={itemListStructuredData}
      />

      <HeroWhisky categoriaSeleccionada={categoriaSeleccionada} setCategoriaSeleccionada={setCategoriaSeleccionada} />

      <Container ref={topRef} className="backGround d-flex flex-column">
        <div className="contentWhisky text-center py-4 container-fluid">
          <h1>Nuestros whiskys</h1>
          <h2>Sabores que cuentan historias. Seleccioná el tuyo</h2>
        </div>

        <div className="filter-container d-flex flex-wrap justify-content-right align-items-center">
          <div className="contenedor-de-search-container">
            <div className="search-container d-flex justify-content-left">
              <FontAwesomeIcon icon={faSearch} className="search-icon" />
              <input
                type="text"
                placeholder="Buscar..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
          </div>

          <div className="filter-dropdown">
            <label>Tipo de whisky: </label>
            <select value={tipoWhiskySeleccionado} onChange={(e) => setTipoWhiskySeleccionado(e.target.value)}>
              {tiposWhisky.map((tipo) => (
                <option key={tipo} value={tipo}>{tipo}</option>
              ))}
            </select>
          </div>

          <div className="filter-dropdown">
            <label>Ordenar por precio: </label>
            <select value={ordenPrecio} onChange={(e) => setOrdenPrecio(e.target.value)}>
              <option value="">Todos</option>
              <option value="asc">Menor a mayor</option>
              <option value="desc">Mayor a menor</option>
            </select>
          </div>



        </div>

        <div className="d-flex flex-wrap gap-3 justify-content-center">
          {currentProducts.length === 0 ? (
            <p className="noHayCoincidencia">No hay productos que coincidan con tu búsqueda.</p>
          ) : (
            currentProducts.map((producto) => (
              <Card
                key={producto._id}
                className="producto-card producto-card-clickable"
                onClick={() => navigate(`/productos/${producto.slug}`)}
              >
                <div className="producto-imagen-container">
                  {producto.enPromocion && (
                    <div className="cartel-promocion">🔥 En promoción</div>
                  )}

                  <div className="contImg">
                    <Card.Img variant="top" src={producto.imagen} alt={producto.nombre} className="producto-imagen" />
                  </div>
                </div>
                <Card.Body className="productosDestaBody">
                  <Card.Title className="tituloCardDes">{producto.nombre}</Card.Title>
                  <Card.Text className="text-muted">{producto.categoria?.nombre || "Categoría"}</Card.Text>
                  {producto.enPromocion ? (
                    <div className="precio-promo-container">
                      <span className="precio-tachado">${producto.precio.toLocaleString("es-AR")}</span>
                      <span className="precio-promocion">
                        ${parseFloat(producto.precioPromocion).toLocaleString("es-AR")}
                      </span>
                    </div>
                  ) : (
                    <Card.Text className="producto-precio">
                      ${producto.precio.toLocaleString("es-AR")}
                    </Card.Text>
                  )}


                  <div className="contenedorBotonesCard">
                    <Button className="botonHoverDetalle" >
                      <Link to={`/productos/${producto.slug}`} className="btn-link fw-bold">
                        Ver detalle
                      </Link>
                    </Button>
                  </div>

                </Card.Body>

              </Card>
            ))
          )}
        </div>

        {totalPages > 1 && (
          <div className="pagination-container py-2">
            <button className="pagination-btn" onClick={prevPage} disabled={currentPage === 1}>Anterior</button>
            <span>Página {currentPage} de {totalPages}</span>
            <button className="pagination-btn" onClick={nextPage} disabled={currentPage === totalPages}>Siguiente</button>
          </div>
        )}
      </Container>
    </div>
  );
};

export default Productos;
